// extracted by mini-css-extract-plugin
export var center = "builder-module--center--qgpq7";
export var container = "builder-module--container--I3Zka";
export var dark = "builder-module--dark--MPD7A";
export var left = "builder-module--left--gT6Fx";
export var right = "builder-module--right--aQGhn";